import { TransparencyList } from './List'
import { TransparencyHeading } from './Heading'
import classNames from 'classnames'
import { Button } from '@noissue-ui-kit/oldBranding/button'
import { ITransparency } from './Transparency.types'

export function Transparency({
  transparencySectionLeftHeading,
  transparencySectionHeading,
  transparencySectionSubHeading,
  transparencySectionDescription,
  transparencyList,
  transparencyButtonLabel,
  transparencyButtonLink,
}: ITransparency) {
  return (
    <div
      className="relative pt-64 pb-64 overflow-hidden bg-white md:pt-72 md:pb-72 xl:pt-44"
      id="our-ideology"
    >
      <div
        className={classNames(
          'absolute z-10 hidden m-auto text-sm -top-0 -bottom-0 left-16 h-14 rounded-3xl xl:block',
          'text-pitaya bg-white w-[121px] transform rotate-90 shadow-[0_1px_4px_0_rgba(23,23,44,0.14)]'
        )}
      >
        <span className="inline-block text-xl font-bold text-center transform rotate-180 w-[121px] h-[40px] leading-[40px]">
          {transparencySectionLeftHeading}
        </span>
      </div>
      <div className={`px-4 max-w-[1156px] lg:px-10 xl:px-5 relative mx-auto`}>
        <div
          className={classNames(
            "absolute bg-contain h-[770px] w-[90%] -top-[145px] right-0 bg-[url('/aboutus/ideology-lft-bg.png')] bg-no-repeat",
            'md:w-[642px] lg:left-[27px] xl:-top-[99px] xl:-left-[133px] xl:w-[802px]'
          )}
        />
        <div
          className={classNames(
            'relative z-10 px-8 pt-16 pb-20 bg-white rounded-xl shadow-[0_2px_30px_0_rgba(178,178,178,0.5)]',
            "after:content-[''] after:w-[81px] after:h-[83px] after:absolute after:bg-contain after:-bottom-0",
            "after:-right-0 after:bg-[url('/aboutus/page-curl.png')] after:bg-no-repeat",
            'md:p-12 md:pb-24 lg:pb-32 lg:pl-40 lg:pr-20 lg:pt-28 md:after:w-[134px] md:after:h-[139px]'
          )}
        >
          <TransparencyHeading
            heading={transparencySectionHeading}
            subHeading={transparencySectionSubHeading}
            descriptions={transparencySectionDescription}
          />
          <TransparencyList transparencyList={transparencyList} />
          <div className="inline-block w-full mt-10 text-left md:mt-24 md:text-center">
            <Button
              href={transparencyButtonLink}
              Component="a"
              size="m"
              corners="square"
              className="min-w-[160px]"
            >
              {transparencyButtonLabel}
            </Button>
          </div>
        </div>
        <div
          className={classNames(
            "absolute bg-contain bg-[url('/aboutus/transparency-back-bg.png')] bg-no-repeat",
            '-right-[23px] -bottom-[130px] w-[230px] h-[252px]',
            'md:-bottom-[145px] md:-right-[101px] md:w-[735px] md:h-[520px]'
          )}
        />
      </div>
    </div>
  )
}
